import { InjectionToken } from '@angular/core';

export const REQUEST = new InjectionToken<string>('REQUEST');



// WEBPACK FOOTER //
// ./Client/app/shared/constants/request.ts